class ClientModel {
  constructor(data) {
    this.id = data.id || null;
    this.code_client = data.code_client || null; // UUID unique
    this.user_id = data.user_id || null; // lien avec utilisateur

    this.nom_affichage = data.nom_affichage || null;
    this.nom_contact = data.nom_contact || null;
    this.email = data.email || null;
    this.telephone = data.telephone || null;

    this.adresse_ligne1 = data.adresse_ligne1 || null;
    this.adresse_ligne2 = data.adresse_ligne2 || null;
    this.code_postal = data.code_postal || null;
    this.ville = data.ville || null;
    this.code_pays = data.code_pays || "FR";

    this.siret = data.siret || null;
    this.numero_tva = data.numero_tva || null;

    this.notes = data.notes || null;

    // Métadonnées
    this.created_at = data.created_at || null;
    this.updated_at = data.updated_at || null;
    this.deleted_at = data.deleted_at || null;
  }
}

export default ClientModel;
